import { i18n } from '@/plugins/i18n'

export const defaultSystemStatuses = [
  'created',
  'new',
  'followUp',
  'unreached',
  'unreachedAtAll',
  'noFurtherContact',
  'reached',
  'appointmentOnSite',
  'orderReceived'
]

const status = Object.defineProperties({}, Object.fromEntries(defaultSystemStatuses.map(key => [
  key,
  { enumerable: true, get: () => i18n.t(`enums.leadStatus.${key}`) }
])))

export const statusForSelect = status

export default status
